import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchCurrentUser,
  reset,
  resetFilters,
  setCurrentPreset,
  updateSelectStore
} from "./redux/locationsSelectorSagas";
import LoadingAnimation from "../../components/loadingAnimation/loadingAnimation";
import { AngleIcon, MapPinIcon } from "../../assets/images/svg";
import { Edit } from "./smartComponents/Edit";
import { MainFilters } from "./smartComponents/Filters";
import { SelectStore } from "./smartComponents/SelectStore";
import { Rename } from "./smartComponents/Rename";
import { CreatePreset } from "./smartComponents/CreatePreset";
import { Delete } from "./smartComponents/Delete";
import "./locationsSelector.scss";

export function LocationsSelectorModule({ params }) {
  const dispatch = useDispatch();
  const ref = useRef();

  const [open, setOpen] = useState(false);
  const [activeTab, setActiveTab] = useState(1);

  const [edit, setEdit] = useState(false);
  const [createPreset, setCreatePreset] = useState({ type: "regular", isOpen: false });

  const [popup, setPopup] = useState({
    rename: false,
    delete: false
  });

  const openPopup = (type) => {
    setPopup((prev) => ({ ...prev, [type]: true }));
  };

  const closePopup = (type) => {
    return () => setPopup((prev) => ({ ...prev, [type]: false }));
  };

  const handlePopup = (item, popupType, presetType) => {
    dispatch(setCurrentPreset({ ...item, type: presetType }));

    openPopup(popupType);
  };

  const isLoading = useSelector((state) => state.locations.isLoading);
  const stores = useSelector((state) => state.locations.selectedFilters.stores);
  const triggerText = useSelector((state) => state.locations.triggerText);

  useEffect(() => {
    dispatch(fetchCurrentUser(params));
  }, []);

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (
        ref.current &&
        !ref.current.contains(e.target) &&
        !e.target.classList.contains("ReactModal__Overlay") &&
        !e.defaultPrevented
      ) {
        setOpen(false);
        setEdit(false);
        setActiveTab(1);
        dispatch(reset());
      }
    };

    if (open) {
      document.addEventListener("click", handleOutsideClick);
    } else {
      document.removeEventListener("click", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [open]);

  const toggleMenu = () => {
    let overlay = document.querySelector("#globalOverlay");

    if (overlay) {
      overlay.classList.toggle("active");
    }
  };

  const toggle = () => {
    setOpen(!open);
    toggleMenu();
  };

  const update = (e) => {
    e.preventDefault();
    dispatch(updateSelectStore());
    setActiveTab(1);
  };

  const activeTabClassName = "tabs__tab--active";

  if (isLoading)
    return (
      <div id="location-selector">
        <div className="location-selector__loading">
          <LoadingAnimation uiLoader />
        </div>
      </div>
    );

  return (
    <>
      <div id="location-selector">
        <div className="location-selector" ref={ref}>
          <div className="location-selector__trigger" onClick={toggle}>
            <div className="icon">
              <MapPinIcon />
            </div>
            <div className="location-selector__title">{triggerText}</div>
            <div className="icon icon-caret">
              <AngleIcon />
            </div>
          </div>
          {open && (
            <>
              <div className="location-selector__dropdown">
                {edit ? (
                  <Edit setEdit={setEdit} />
                ) : (
                  <div className="tabs">
                    <div className="tabs__list">
                      <button
                        className={`tabs__tab ${activeTab === 0 ? activeTabClassName : ""}`}
                        onClick={() => setActiveTab(0)}
                      >
                        Filters
                      </button>
                      <button
                        className={`tabs__tab ${activeTab === 1 ? activeTabClassName : ""}`}
                        onClick={() => setActiveTab(1)}
                      >
                        Select Store
                      </button>
                    </div>

                    {activeTab === 1 ? (
                      <div className="tabs__section">
                        <SelectStore
                          onClose={() => {
                            toggle();
                          }}
                        />
                      </div>
                    ) : (
                      <div className="tabs__section location-selector__tabs__section-filters">
                        <div className="location-selector__footer">
                          <button
                            className="button button--primary"
                            onClick={update}
                            disabled={!stores.length}
                          >
                            Update
                          </button>

                          <button
                            className="button button--secondary"
                            onClick={() => setCreatePreset({ type: "regular", isOpen: true })}
                            disabled={!stores.length}
                          >
                            Save Preset
                          </button>
                          {params.isCorporate && (
                            <button
                              className="button button--secondary"
                              onClick={() => setCreatePreset({ type: "corporate", isOpen: true })}
                              disabled={!stores.length}
                            >
                              Save Corporate Preset
                            </button>
                          )}

                          <button
                            className="button button--secondary button--no-outline"
                            onClick={() => dispatch(resetFilters())}
                            style={params.isCorporate ? { marginLeft: "16px" } : {}}
                          >
                            Reset
                          </button>
                        </div>
                        <div className="location-selector__body">
                          <MainFilters
                            openEdit={() => setEdit(true)}
                            handlePopup={handlePopup}
                            isCorporate={params.isCorporate}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </>
          )}
        </div>
        {createPreset.isOpen ? (
          <CreatePreset
            isOpen={createPreset.isOpen}
            type={createPreset.type}
            onClose={() => setCreatePreset({ type: "regular", isOpen: false })}
          />
        ) : null}
      </div>
      {popup.rename ? <Rename isOpen={popup.rename} onClose={closePopup("rename")} /> : null}
      {popup.delete ? <Delete isOpen={popup.delete} onClose={closePopup("delete")} /> : null}
    </>
  );
}
